module.exports = __webpack_public_path__ + "img/invite_parent_exchange.b7407ab2.png";